import { Trait } from '../../trait.type';
import type { Die } from '../../die.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import type { Technique } from '../../techniques.type';
import { DieFace } from '../../face.type';
import { SoundType } from '../../sound';
import { dealDamage, type Player } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';

export class BrawlerTrait extends Trait {
  static baseType = TraitType.Brawler;
  static baseTitle = 'Brawler';
  static baseText = 'Gives access to the Heavy Punch Technique.';
  static baseIcon = 'trait';

  type = BrawlerTrait.baseType;
  title = BrawlerTrait.baseTitle;
  text = BrawlerTrait.baseText;
  icon = BrawlerTrait.baseIcon;

  getTechniques(techniques: Technique[]): Technique[] {
    return [
      {
        ingredients: [DieFace.Fist],
        title: 'Heavy Punch',
        text: 'Deal 1 damage, gain double bonus from Strength.',
        tags: ['damage'],
        audio: SoundType.AttackBlunt,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          let strength = source.statusEffects.find((modifier) => {
            return modifier.type == StatusEffect.Strength;
          });
          if (strength) {
            dealDamage({ value: 1 + strength.stacks, target, source, dice });
          } else {
            dealDamage({ value: 1, target, source, dice });
          }
        },
      },
    ];
  }
}

TraitRegistry.register(BrawlerTrait.baseType, BrawlerTrait);
